export interface ApiAddTranslationAsyncTaskRequest {
    current_step: string;
    task_id: string;
}

export const AddTranslationAsyncTask = Symbol('AddTranslationAsyncTask');

export interface AddTranslationAsyncTask {
    addTranslationAsyncTask(data: ApiAddTranslationAsyncTaskRequest): Promise<void>;
}